import IsiPemberitahuan from "./src/IsiPemberitahuan";

export default IsiPemberitahuan